import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { backendBaseUrl } from '../../constants/app.constants.js';
import { useNavigate } from 'react-router-dom';
import { fetchTemplate, updateAllInstructions, updateTemplate, getUpdateStatus } from '../../services/page.services.js';

function TemplateEditPage() {
  const [templateText, setTemplateText] = useState('');
  const [isUpdatingTemplate, setIsUpdatingTemplate] = useState(false);
  const [isUpdatingModel, setIsUpdatingModel] = useState(false);
  const [status, setStatus] = useState(null); // 상태 정보를 저장할 상태 변수 추가
  const navigate = useNavigate();

  const fetchData = async () => {
    const templateText = await fetchTemplate();
    console.log('response:', templateText);
    setTemplateText(templateText); // 초기화
  };
  
  useEffect(() => {
    fetchData();
  }, []);

  const handleChange = (e) => {
    setTemplateText(e.target.value);
  };

  const handleTemplateEdit = async () => {
    if(isUpdatingTemplate) {
      console.log('Template update is in progress...');
      return;
    }
    if(isUpdatingModel) {
      console.log('Model update is in progress...');
      return;
    }
    setIsUpdatingTemplate(true); // 업데이트 시작
    try {
      await updateTemplate(templateText);
    } catch (error) {
      alert("Failed to update template. Please try again."); // 에러 알림 메시지
      console.error("Failed to update template:", error);
    } finally {
      setIsUpdatingTemplate(false); // 업데이트 종료
    }
  };

  const handleModelUpdate = async () => {
    if (isUpdatingTemplate) {
      console.log('Waiting for template update to complete...');
      return; // 템플릿 업데이트가 끝날 때까지 대기
    }
    if(isUpdatingModel) {
      console.log('Model update is in progress...');
      return;
    }
    setIsUpdatingModel(true); // 업데이트 시작
    try{
      await updateAllInstructions();
    } catch (error) {
      alert("Failed to update model. Please try again."); // 에러 알림 메시지
      console.error("Failed to update model:", error);
    } finally {
      setIsUpdatingModel(false); // 업데이트 종료
    }

  };
  
  const handleStatusCheck = async () => {
    try {
      const response = await getUpdateStatus(); // getUpdateStatus 호출이 비동기이므로 await 추가
      setStatus(response); // 상태 정보를 상태 변수에 저장
    } catch (error) {
      alert("Failed to check status. Please try again."); // 에러 알림 메시지
      console.error("Failed to check status:", error);
    }
  };

  return (
    <div style={{ padding: '20px', height: '100vh', overflowY: 'auto' }}>
      <h2>프롬프트 템플릿 수정</h2>
      <button onClick={() => navigate('/persona-community')} style={{ margin: '10px' }}>뒤로 가기</button>
      <textarea
        value={templateText}
        onChange={handleChange}
        style={{ width: '100%', minHeight: '80vh', resize: 'none' }}
      />
      <button onClick={handleTemplateEdit} style={{ margin: '10px' }}>프롬프트 수정</button>
      <button onClick={handleModelUpdate} style={{ margin: '10px' }}>모델 전체 업데이트</button>
      <button onClick={handleStatusCheck} style={{ margin: '10px' }}>status 확인</button>

      {/* 상태 정보가 있으면 한 줄로 버튼 옆에 표시 */}
      {status && (
        <span style={{ color: 'white', marginLeft: '10px' }}>
          완료: {status.COMPLETE} | 실패: {status.FAILED} | 대기 중: {status.PENDING}
        </span>
      )}
    </div>
  );
}

export default TemplateEditPage;
